<template>
  <div data-aos="fade-right" style="background-color: #ececee">
    <el-row :gutter="20" class="hidden-sm-and-down tamanio-edit" style="padding: 0px 0px; display: flex; align-items: center">
      <el-col :md="8" :sm="10"
        ><div>
          <div class="image-wrapper">
            <img class="tamanio-edit" :src="require('@/assets/fotos/BENEFICIOS.jpg')" />
          </div>
        </div>
      </el-col>
      <el-col :md="16" :sm="14"
        ><h2 class="title_desarrollo padding-desarrollo" style="margin: 0px">{{ $t('beneficios.titulo') }}</h2>

        <div v-for="o in $t('beneficios.mensajes')" :key="o" class="text item">
          <span class="padding-desarrollo" style="color: #d35400; font-weight: 700; padding-right: 10px">+</span> <span class="text_beneficios" v-html="o"></span></div
      ></el-col>
    </el-row>
    <el-row :gutter="20" class="hidden-md-and-up tamanio-edit" style="padding: 0px 0px">
      <el-col :md="8" :sm="24"
        ><div>
          <div class="image-wrapper">
            <img style="height: 25vh" class="alt_img" :src="require('@/assets/fotos/BENEFICIOS.jpg')" />
          </div>
        </div>
      </el-col>

      <el-col :md="16" :sm="24" class="hidden-md-and-up" style="background-color: #ececee">
        <div class="respondable-style">
          <h2 class="title_desarrollo">{{ $t('beneficios.titulo') }}</h2>

          <div v-for="o in $t('beneficios.mensajes')" :key="o" class="text item">
            <span style="color: #d35400; font-weight: 700; padding-right: 10px">+</span> <span class="text_beneficios" v-html="o"></span>
          </div>
        </div> </el-col
    ></el-row>
  </div>
</template>
<script>
// import accounting from 'accounting'
// import ICountUp from 'vue-countup-v2'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  // components: { ICountUp },

  data() {
    return {}
  },

  mounted() {
    AOS.init({
      duration: 1000,
      offset: 100,
      once: false, // false = animaciones se repiten al volver a scrollear
    })
  },
}
</script>
<style scoped>
.button-group >>> .el-button {
  margin: 5px;
  border-color: #ccc;
}

/* estilo cuando el botón está seleccionado */
.button-group >>> .active-button {
  color: #fff !important;
  background-color: #d35400 !important;
  border-color: #e9eef3 !important;
}
/* .button-left >>> .el-button:hover,
.button-left >>> .el-button:active {
  color: #fff !important;
  border-color: #e9eef3;
  background-color: #d35400;
} */
</style>
<style>
.padding-desarrollo {
  margin: 0px;
  padding: 0px 5%;
}
.title_beneficio {
  color: #d35400;
  font-family: 'roboto-cursiva-bold';
  padding-bottom: 2.5%;
  margin: 0px;
}
.text_beneficios {
  font-family: 'roboto-regular';
  line-height: 1.5;
  color: #4b4b4a;
}
@media (min-width: 2561px) {
  .tamanio-edit {
    height: 400px !important;
  }
  .title_beneficio {
    font-size: 50px;
    padding-bottom: 25px;
  }
  .text_beneficios {
    font-size: 23px;
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .tamanio-edit {
    height: 400px !important;
  }
  .title_beneficio {
    font-size: 50px;
    padding-bottom: 20px;
  }
  .text_beneficios {
    font-size: 23px;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .tamanio-edit {
    height: 320px !important;
  }
  .title_beneficio {
    font-size: 45px;
    padding-bottom: 20px;
  }
  .text_beneficios {
    font-size: 21px;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .tamanio-edit {
    height: 300px !important;
  }
  .title_beneficio {
    font-size: 40px;
  }
  .text_beneficios {
    font-size: 18px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .tamanio-edit {
    height: 350px !important;
  }
  .title_beneficio {
    font-size: 33px;
  }
  .text_beneficios {
    font-size: 16px;
  }
  .alt_img {
    height: 35vh !important;
  }
  .respondable-style {
    padding: 10% 10% 10% 10%;
  }
}
@media screen and (min-width: 599px) and (max-width: 767px) {
  .title_beneficio {
    padding-bottom: 5%;
  }
  .alt_img {
    height: 25vh !important;
  }
}
@media screen and (min-width: 480px) and (max-width: 598px) {
  .title_beneficio {
    padding-bottom: 5%;
  }
  .alt_img {
    height: 30vh !important;
  }
}
@media screen and (min-width: 376px) and (max-width: 480px) {
  .title_beneficio {
    padding-bottom: 5%;
  }
}

@media (max-width: 375px) {
  .title_beneficio {
    padding-bottom: 5%;
  }
}
</style>
